import {
  XPlatformIcon,
  InstagramPlatformIcon,
  TiktokPlatformIcon,
  YoutubePlatformIcon,
  LinkedInPlatformIcon
} from '@/components/icons';

export const getPlatformIcon = (platform: string) => {
  switch (platform) {
    case 'youtube':
      return <YoutubePlatformIcon />;
    case 'tiktok':
      return <TiktokPlatformIcon />;
    case 'instagram':
      return <InstagramPlatformIcon />;
    case 'twitter':
      return <XPlatformIcon />;
    case 'linkedin':
      return <LinkedInPlatformIcon />;
    default:
      return <div />;
  }
};

export const getPlatformName = (platform: string) => {
  switch (platform) {
    case 'youtube':
      return 'YouTube';
    case 'tiktok':
      return 'TikTok';
    case 'instagram':
      return 'Instagram';
    case 'twitter':
      return 'Twitter (X)';
    case 'linkedin':
      return 'LinkedIn';
    default:
      return platform;
  }
};

export const PlatformIconComponent: React.FC<{
  platform: string;
  className?: string;
}> = ({ platform, className }) => {
  switch (platform) {
    case 'youtube':
      return <YoutubePlatformIcon className={className} />;
    case 'tiktok':
      return <TiktokPlatformIcon className={className} />;
    case 'instagram':
      return <InstagramPlatformIcon className={className} />;
    case 'twitter':
      return <XPlatformIcon className={className} />;
    case 'linkedin':
      return <LinkedInPlatformIcon className={className} />;
    default:
      return <div />;
  }
};
